import { render, staticRenderFns } from "./painel.vue?vue&type=template&id=27f41cc7"
import script from "./painel.vue?vue&type=script&lang=js"
export * from "./painel.vue?vue&type=script&lang=js"
import style0 from "./painel.vue?vue&type=style&index=0&id=27f41cc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports